function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 8.33334H13.95C13.6382 7.12584 12.994 6.03 12.0905 5.17034C11.1871     4.31068 10.0606 3.72167 8.83911 3.47024C7.61762 3.21881 6.35009 3.31504 5.18056     3.748C4.01102 4.18096 2.98638 4.93329 2.22305 5.91949C1.45973 6.9057 0.988336     8.08624 0.862433 9.32697C0.736531 10.5677 0.96117 11.8189 1.51082 12.9383C2.06048     14.0578 2.91311 15.0006 3.97183 15.6596C5.03055 16.3187 6.25291 16.6676 7.50001     16.6667H15C16.1051 16.6667 17.1649 16.2277 17.9463 15.4463C18.7277 14.6649 19.1667     13.6051 19.1667 12.5C19.1667 11.3949 18.7277 10.3351 17.9463 9.55373C17.1649 8.77233     16.1051 8.33334 15 8.33334Z",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgErplyCloud = function SvgErplyCloud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgErplyCloud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/erply_cloud.8b11ac36.svg";
export { ForwardRef as ReactComponent };